import React from 'react';
import { VirtualTableHeadCell } from "../../virtualized-table/types";
import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import DownloadFile from "../download-file";
import { DefaultCheckbox } from './default-checkbox';

export const panelFilesHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'panelName',
        Header: 'Panel Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'vimsFileName',
        Header: 'VIMS Config File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'vimsSha1',
        Header: 'VIMS SHA Value',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'updatedAt',
        Header: 'Last Updated Date ',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'updatedBy',
        Header: 'Last Updated By ',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'isDefault',
        Header: 'Default',
        component: DefaultCheckbox,
        width: 60,
    },
    {
        accessor: 'downloadIcon',
        Header: 'Download',
        component: DownloadFile,
    },
];

export const panelFilesHeadCellsSortableAccessors = {
    panelName: true,
    vimsFileName: true,
    vimsSha1: true,
    updatedAt: true,
    updatedBy: true
};

export const vimsConfigHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'generationType',
        Header: 'Gen Type',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        width: 90,

    },
    {
        accessor: 'fileName',
        Header: 'File Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        width: 140
    },
    {
        accessor: 'id',
        Header: 'SHA Value',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
        width: 300,
    },
];

export const vimsConfigSortableAccessors = {
    fileName: true,
    date: true,
    partNumber: true,
    id: true,
    generationType: true,
};
